const chartJS = require('chart.js')
const module = angular.module('chartJS', []);

chartJS.Chart.register(...chartJS.registerables);

chartJS.Chart.defaults.backgroundColor = '#000';
chartJS.Chart.defaults.borderColor = '#9ca3af';
chartJS.Chart.defaults.color = '#9ca3af';

module.directive('chartJs', function () {
    return {
        restrict: 'A',
        scope: {
            chartJsOptions: '<'
        },
        link: function (scope, element, attrs) {
            if (element[0].nodeName !== 'CANVAS') {
                throw new Error('chart-js directive can only be used on <canvas> elements.');
            }

            let cjs = null;

            function init() {
                cjs = new chartJS.Chart(element, Object.assign({}, scope.chartJsOptions || {}))
            }

            function cleanup() {
                if (cjs) {
                    cjs.destroy();
                    cjs = null;
                }
            }

            init();

            scope.$on('$destroy', () => {
                cleanup();
            });

            scope.$watch('chartJsOptions', (newVal, oldVal) => {
                if (cjs) {
                    cjs.options = angular.copy(scope.chartJsOptions.options);
                    cjs.data = angular.copy(scope.chartJsOptions.data);
                    cjs.update();
                } else {
                    init();
                }
            }, true)
        }
    };
});